<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('CarrierList.carrierList')">
                <template v-slot:left>
                    <i class="fa fa-truck fa-3x text-billing"/>
                </template>
            </PageTitle>
            <transition mode="out-in" name="fade">
                <APILoading v-if="carriers === undefined" key="loading" :color="$data.$colors.billing" :text="$t('CarrierList.loadingCarriers')"/>
                <div v-else key="carriers" class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <v-client-table :data="carriers" :columns="table.columns" :options="table.options">
                                    <router-link class="font-bold" slot="name" slot-scope="props"
                                                 :to="`carrier/${props.row.id}`" v-html="props.row.name"/>
                                    <button @click="showCarrierModal()" class="btn btn-primary pull-right" slot="afterLimit">
                                        <i class="fa fa-plus-circle mr-1"/>
                                        <span v-html="$t('CarrierList.addCarrier')"/>
                                    </button>
                                    <CarrierChargesBy slot-scope="props" slot="chargesBy" :carrier="props.row"/>
                                    <BooleanIcon slot-scope="props" slot="enabledForProduction" :boolean="props.row.enabledForProduction"/>
                                    <BooleanIcon slot-scope="props" slot="enabledForDistribution" :boolean="props.row.enabledForDistribution"/>
                                    <BooleanIcon slot-scope="props" slot="needsGLN" :boolean="props.row.needsGLN"/>
                                    <BooleanIcon slot-scope="props" slot="private" :boolean="props.row.private"/>
                                    <div class="text-center" slot="actions" slot-scope="props">
                                        <router-link v-tooltip="$t('CarrierList.see')" class="btn btn-info btn-xs" :to="`carrier/${props.row.id}`">
                                            <i class="fa fa-eye"/>
                                        </router-link>
                                        <button v-tooltip="$t('CarrierList.edit')" @click="showCarrierModal(props.row)" class="btn btn-warning btn-xs ml-1">
                                            <i class="fa fa-edit"/>
                                        </button>
                                    </div>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <CarrierFormModal @addCarrier="addCarrier" @editCarrier="editCarrier" ref="CarrierFormModal"/>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "../../../shared/misc/PageTitle";
import Carrier from "../../../../classes/Billing/Carrier/Carrier";
import APILoading from "../../../shared/API/APILoading";
import CarrierFormModal from "../../../shared/Billing/Carrier/CarrierFormModal";
import BooleanIcon from "../../../shared/misc/BooleanIcon";
import { permissiveFilter } from "../../../../helpers/VueTable";
import CarrierChargesBy from "../../../shared/Billing/Carrier/CarrierChargesBy";

export default {
    name: "CarrierList",
    components: {CarrierChargesBy, BooleanIcon, CarrierFormModal, APILoading, PageTitle},
    // eslint-disable-next-line max-lines-per-function
    data() {
        return {
            carriers: undefined,
            table: {
                columns: ["name", "chargesBy", "enabledForProduction", "enabledForDistribution", "needsGLN", "private", "actions"],
                options: {
                    sortable: ["name", "chargesBy", "enabledForProduction", "enabledForDistribution", "needsGLN", "private"],
                    perPage: 10,
                    headings: {
                        name: this.$t("CarrierList.name"),
                        chargesBy: this.$t("CarrierList.chargesBy"),
                        enabledForProduction: this.$t("CarrierList.enabledForProduction"),
                        enabledForDistribution: this.$t("CarrierList.enabledForDistribution"),
                        needsGLN: this.$t("CarrierList.needsGLN"),
                        private: this.$t("CarrierList.private"),
                        actions: this.$t("CarrierList.actions"),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                        chargesBy: (row, query) => permissiveFilter(row.chargesByLabel, query),
                    },
                },
            },
        };
    },
    async created() {
        await this.checkUserAuthentication();
        await this.getCarriers();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
        async getCarriers() {
            try {
                const response = await this.$diceAPI.getCarriers();
                this.carriers = response.data.map(carrier => new Carrier(carrier));
            } catch (e) {
                this.$displayError(e);
            }
        },
        addCarrier(carrier) {
            this.carriers.push(new Carrier(carrier));
        },
        editCarrier(newCarrier) {
            const index = this.carriers.findIndex(carrier => carrier.id === newCarrier.id);
            this.carriers.splice(index, 1, new Carrier(newCarrier));
        },
        showCarrierModal(carrier = null) {
            this.$refs.CarrierFormModal.show(carrier);
        },
    },
};
</script>

<style scoped>

</style>